function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement, createRef, isValidElement } from 'react';
import PropTypes from 'prop-types';
import OpenableComponent from '../OpenableComponent';
import { classNamesFor } from '../utils/classNames';
import FocusTrap from '../FocusTrap';
import ClickAway from '../ClickAway';
import ScrollView from '../ScrollView';
var cx;
/**
 * The SidePanel component is a modal layered UI. It is used to present
 * additional information over the main page. It is designed to work with
 * @sie/web-common-layers and the UiLayers component.
 *
 * - [DIG20 ATLAS spec](https://atlas.np.tools.playstation.net/design/770f2460-acd3-4257-94f7-6179a48b868b/7?bounds=-5.291,0.000,11.583,7.773)
 */

var SidePanel = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(SidePanel, _OpenableComponent);

  var _super = _createSuper(SidePanel);

  function SidePanel(props) {
    var _this;

    _classCallCheck(this, SidePanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onScrolledTop", function () {
      _this._root.current.classList.remove('psw-is-scrolled');
    });

    _defineProperty(_assertThisInitialized(_this), "onScrolledFromTop", function () {
      _this._root.current.classList.add('psw-is-scrolled');
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAway", function (event) {
      event.stopPropagation();

      _this.close();
    });

    _this._root = /*#__PURE__*/createRef();
    _this._content = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(SidePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var openOnMount = this.props.openOnMount;

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this2.open();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          header = _this$props.header,
          footer = _this$props.footer,
          qa = _this$props.qa,
          shell = _this$props.shell;
      var isOpen = this.isOpen();

      var _SidePanel$getClassNa = SidePanel.getClassName({
        className: className,
        isOpen: isOpen
      }),
          root = _SidePanel$getClassNa.root,
          paneClass = _SidePanel$getClassNa.pane,
          headerClass = _SidePanel$getClassNa.header,
          contentClass = _SidePanel$getClassNa.content;

      return /*#__PURE__*/React.createElement("div", {
        className: root,
        "data-qa": qa
      }, /*#__PURE__*/React.createElement(FocusTrap, {
        as: "aside",
        ref: this._root,
        className: paneClass,
        onEscape: this.close,
        trap: isOpen,
        includeWrapper: true
      }, /*#__PURE__*/React.createElement(ClickAway, {
        className: "psw-fill psw-l-stack-left",
        onClickAway: this.onClickAway
      }, /*#__PURE__*/isValidElement(header) && /*#__PURE__*/cloneElement(header, {
        className: headerClass,
        onClose: this.close
      }), !!shell && children, !shell && /*#__PURE__*/React.createElement(ScrollView, {
        as: "section",
        className: "psw-fill-x",
        overflowEffect: "none",
        onScrolledTop: this.onScrolledTop,
        onScrolledFromTop: this.onScrolledFromTop
      }, /*#__PURE__*/React.createElement("div", {
        className: contentClass
      }, children)), /*#__PURE__*/isValidElement(footer) && /*#__PURE__*/cloneElement(footer, {
        ctaLayout: 'always-stack'
      }))));
    }
  }]);

  return SidePanel;
}(OpenableComponent);

SidePanel.getClassName = function (_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen;
  return {
    root: cx('psw-side-panel', 'psw-l-full-screen', isOpen && 'psw-pointer-events-on', isOpen && 'psw-is-open', 'psw-l-line-right', className),
    pane: cx('psw-side-panel-pane', 'psw-l-w-side-panel', 'psw-c-bg-2', 'psw-fill-y', 'psw-l-anchor', 'psw-l-stack-left', 'psw-s-1'),
    header: cx('psw-m-x-6'),
    content: cx('psw-side-panel-content', 'psw-fill-x', 'psw-p-x-6', 'psw-p-b-8', 'psw-scroll-y', 'psw-fill-y')
  };
};

SidePanel.defaultProps = {
  children: null,
  className: '',
  header: null,
  footer: null,
  isOpen: null,
  closeDelay: 300,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  openOnMount: null,
  qa: '',
  shell: false
};
SidePanel.propTypes = {
  /**
   * SidePanel content
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.arrayOf(PropTypes.any)]),

  /**
   * Add custom classes to the SidePanel
   */
  className: PropTypes.string,

  /**
   * Optional header content
   */
  header: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * Optional footer content
   */
  footer: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * If set to null the state will be managed internally. If a boolean is passed
   * the overlay will be controlled
   */
  isOpen: PropTypes.bool,

  /**
    * Event callback called when the SidePanel is closed
    */
  onClose: PropTypes.func,

  /**
   * Event callback called when the SidePanel is opened
   */
  onOpen: PropTypes.func,

  /**
   * Whether or not the panel should be opened immediately upon mounting
   */
  openOnMOunt: PropTypes.bool,

  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * The shell prop allows you to handle the layout of the content area yourself. This is helpful
   * when rendering an iframe within the panel. Generally the default (i.e. shell=false) should
   * be preferred
   */
  shell: PropTypes.bool
};
cx = classNamesFor(SidePanel);
export default SidePanel;